import "../../css/home/footer.css";
import facebook from "../../../images/svg/facebook-logo.png";
import insta from "../../../images/svg/instagram.png";
import youtube from "../../../images/svg/youtube-logo.png";
import twitter from "../../../images/svg/twitter.png";

const Footer = () => {
  return (
    <footer className="new_footer_area">
      <div className="new_footer_top">
        <div className="footer_row">
          <div className="section_mail">
            <h3 className="title_footer">Inscrivez-vous</h3>
            <span className="mailDescript">
              Inscrivez-vous et nous vous enverrons les meilleures offres
            </span>
            <form className="mail_form">
              <input type="email" placeholder="Votre adresse e-mail" />
              <button>S'abonner</button>
            </form>
          </div>
          <div className="section_distribution">
            <h3 className="title_footer">Téléchargement</h3>
            <ul class="list-unstyled">
              <li>
                <a href="/">Entrepises</a>
              </li>
              <li>
                <a href="/">Application Android</a>
              </li>
              <li>
                <a href="/">Application IOS</a>
              </li>
              <li>
                <a href="/">Ordinateur</a>
              </li>
              <li>
                <a href="/">Projets</a>
              </li>
              <li>
                <a href="/">Mes taches</a>
              </li>
            </ul>
          </div>
          <div className="section_Help">
            <h3 className="title_footer">Aide</h3>
            <ul class="list-unstyled">
              <li>
                <a href="/">FAQ</a>
              </li>
              <li>
                <a href="/">Term &amp; conditions</a>
              </li>
              <li>
                <a href="/">Reporting</a>
              </li>
              <li>
                <a href="/">Documentation</a>
              </li>
              <li>
                <a href="/">Support Policy</a>
              </li>
              <li>
                <a href="/">Privacy</a>
              </li>
            </ul>
          </div>
          <div className="section_reseau">
            <h3 className="title_footer">Solutions d'équipe</h3>
            <div class="f_social_icon">
              <a href="https://www.facebook.com/" className="fab">
                {" "}
                <img
                  src={facebook}
                  className="f_social"
                  alt="Facebook logo icons created by Freepik - Flaticon"
                />
              </a>
              <a href="https://www.x.com/" className="fab">
                {" "}
                <img
                  src={twitter}
                  className="f_social"
                  alt="Tweet icons created by Freepik - Flaticon"
                />{" "}
              </a>
              <a href="https://www.youtube.com/" className="fab">
                {" "}
                <img
                  src={youtube}
                  className="f_social"
                  alt="Youtube icons created by Dave Gandy - Flaticon"
                />{" "}
              </a>
              <a href="https://www.instagram.com/-" className="fab">
                {" "}
                <img
                  src={insta}
                  className="f_social"
                  alt="Instagram icons created by Freepik - Flaticon"
                />{" "}
              </a>
            </div>
          </div>
        </div>
        <div className="footer_bg">
          <div className="footer_bg_one"></div>
          <div className="footer_bg_two"></div>
        </div>
      </div>

      <div className="footer_bottom">
        <div className="footer_bottom_container">
          <div>
            <p>© 2024 SOMO. Tous les droits sont réservés.</p>
          </div>
          <div>
            <p>
              Conçu par <i className="icon_heart"> </i>{" "}
              <a href="http://ucodebyus.com"> UCODEBYUS</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
